import { jsx } from "react/jsx-runtime";
import { useRef, useEffect } from "react";
import ErrorFallback from "./error-fallback/error-fallback.js";
const ControllerError = ({
  children,
  wfConfig,
  onError
}) => {
  const reportedError = useRef();
  const { controllerError } = wfConfig;
  useEffect(() => {
    if (controllerError && reportedError.current?.message !== controllerError.message) {
      reportedError.current = { ...controllerError };
      onError?.(new Error(controllerError.message));
    }
  }, [controllerError, onError]);
  if (controllerError) {
    return /* @__PURE__ */ jsx(
      ErrorFallback,
      {
        errorMessage: controllerError.message,
        errorId: controllerError.id
      }
    );
  }
  return children;
};
export {
  ControllerError as default
};
//# sourceMappingURL=controller-error.js.map
